<template>
<div class="white" style="background: #f2f3f5 !important;">
  <v-container>
    <FinderHeader @setType="setType" :type="type" :title="title" :background="isEdit || !isEdit && token && type !== seeker ? true : false " />
    <FormEdit
      :key="type"
      :currentPlayer="currentPlayer"
      v-if="isEdit"
      :type="type"
      @search="hasSearch = !hasSearch"
      @edit="isEdit=!isEdit"
      @setResult="setResult"
    />
    <FormHostDetail
      v-else-if="!isEdit && token && type !== seeker && checkIsData"
      @edit="isEdit=!isEdit"
      :currentPlayer="currentPlayer"
    />
    <v-row no-gutters v-else-if="type === seeker && !isEdit" justify="center">
      <v-col cols="12" v-if="searchResult.length === 0" class="text-center">
        <translate tag="h3">No result found !</translate>
      </v-col>
      <v-col cols="12" :class="searchResult.length == 0 ? 'text-center' : 'text-right'">
        <v-btn
          depressed
          color="primary"
          class="text-none font-weight-bold my-3 subtitle-2 btn-square"
          @click="[hasSearch = !hasSearch, isEdit=!isEdit]"
        >
          <translate>Make a new search</translate>
        </v-btn>
      </v-col>
      <template v-if="searchResult.length !== 0">
        <v-col cols="12" v-for="(item, idx) in searchResult" :key="idx" class="mb-10">
          <SearchFinderCard :data="item" :dateSearch="dateSearch"/>
        </v-col>
      </template>
    </v-row>

  </v-container>
</div>

</template>

<script>
import FinderHeader from "@/components/Finder/FinderHeader";
import SearchFinderCard from "@/components/Finder/SearchFinderCard";
import AutoForm from "@/components/Forms/AutoForm";
import FormHostDetail from "@/components/Finder/FormHostDetail";
import FormEdit from "@/components/Finder/FormEdit";
export default {
  name: "Finder",
  components: {
    FinderHeader,
    SearchFinderCard,
    AutoForm,
    FormHostDetail,
    FormEdit
  },
  data() {
    return {
      hasSearch: false,
      type: PLAYER_HOST,
      isEdit: false,
      seeker: PLAYER_SEEKER,
      currentPlayer: {},
      searchResult: [],
      dateSearch:{}
    };
  },
  computed: {
    checkIsData() {
      if(Object.keys(this.currentPlayer).length !== 0) {
        return true
      } else {
        return false
      }
    },
    layout() {
      return PlayerFinderForm.layout(this.entity, this.states, this.cities, this.type);
    },
    token() {
      return this.$store.state.auth.token;
    },
    title() {
      if(this.type === PLAYER_SEEKER) {
        return this.isEdit ? this.$gettext('Are you going somewhere and would like to find Golfers to play with you?') : ''
      } else {
        if (this.checkIsData) {
          return this.isEdit ? '' : this.$gettext("Congratulation and thank you to being an active member of BGC community");
        }
        else {
          return this.$gettext("Declare yourself ready to welcome and play with locals or golf travelers");
        }
      }
    }
  },
  methods: {
    async setType(type) {
      this.type = type
      if(this.type === PLAYER_SEEKER) {
        this.isEdit = true
        this.currentPlayer = {}
      } else {
        if (!this.token) {
        const toggle = await this.$store.state.toggle.dialogConfirm.open(
          this.$gettext("Warning"),
          this.$gettext('You need to login'),
          { color: "warning" }
        );
        if (!toggle) {
          this.type = PLAYER_SEEKER
        } else {
          this.$router.push({name: 'login'})
        }
      } else {
        const result = await this.getData()
        const isObj = Object.keys(result).length !== 0
        this.isEdit = isObj ? false : true
        if(result && result.length !== 0) {
          this.currentPlayer = result
        }
      }
      }
    },
    async getData(){
      return await this.$store.dispatch('getDataPlayerFinder')
    },
    setResult(data) {
      this[data.name] = data.val
    }
  },
  async mounted() {
    if(!this.token) {
      this.type = PLAYER_SEEKER
      this.isEdit = true
    } else {
      const result = await this.getData()
      if(result && result.length !== 0) {
        this.currentPlayer = result
      } else {
        this.isEdit = true
      }
    }
  }
};
</script>
